import {
  CDP_SCREENER_OUTCOME_PARAM_KEYS,
  CDP_ZIP_CODE_PARAM_KEYS,
} from '../../lib/utils/screenerOutcomeParams.constants';
import {
  getPrepopulateValueFromSources,
  ScreenerOutcomeParam,
} from '../../lib/utils/screenerOutcomeParams';
import { TextField } from './ContactInfo.types';

export const resolvePrePopulateCheckboxField = (
  isMegaScreenerSite: boolean,
  prePopulateFromScreener?: TextField,
  prePopulateFromMegaScreener?: TextField
) => (isMegaScreenerSite ? prePopulateFromMegaScreener : prePopulateFromScreener);

export const resolveReadOnlyCheckboxField = (
  isMegaScreenerSite: boolean,
  isReadOnly?: TextField,
  isMegaScreenerReadOnly?: TextField
) => (isMegaScreenerSite ? isMegaScreenerReadOnly : isReadOnly);

/** Contact field key → mega outcome / CDP keys (same as mega prepopulate fill). */
const MEGA_PREPOPULATE_FIELD_KEYS: Record<string, string | string[]> = {
  Day: CDP_SCREENER_OUTCOME_PARAM_KEYS.D,
  Month: CDP_SCREENER_OUTCOME_PARAM_KEYS.M,
  Year: CDP_SCREENER_OUTCOME_PARAM_KEYS.Y,
  Gender: [CDP_SCREENER_OUTCOME_PARAM_KEYS.G, 'gender'],
  FirstName: CDP_SCREENER_OUTCOME_PARAM_KEYS.FIRST_NAME,
  ParentFirstName: CDP_SCREENER_OUTCOME_PARAM_KEYS.FIRST_NAME,
  CaregiverFirstName: CDP_SCREENER_OUTCOME_PARAM_KEYS.FIRST_NAME,
  Email: CDP_SCREENER_OUTCOME_PARAM_KEYS.EMAIL,
  ParentEmail: CDP_SCREENER_OUTCOME_PARAM_KEYS.EMAIL,
  CaregiverEmail: CDP_SCREENER_OUTCOME_PARAM_KEYS.EMAIL,
  ParticipantEmail: CDP_SCREENER_OUTCOME_PARAM_KEYS.EMAIL,
  Zipcode: CDP_ZIP_CODE_PARAM_KEYS,
  ZipCode: CDP_ZIP_CODE_PARAM_KEYS,
  ParticipantZipcode: CDP_ZIP_CODE_PARAM_KEYS,
  ParticipantZipCode: CDP_ZIP_CODE_PARAM_KEYS,
  CaregiverZipCode: CDP_ZIP_CODE_PARAM_KEYS,
  ParentZipcode: CDP_ZIP_CODE_PARAM_KEYS,
};

export const hasMegaScreenerPrepopulateValue = (
  fieldName: string | undefined,
  screenerOutcomeParameter: ScreenerOutcomeParam[] | null | undefined,
  cdpData: Parameters<typeof getPrepopulateValueFromSources>[1]
): boolean => {
  if (!fieldName) {
    return false;
  }
  const keys = MEGA_PREPOPULATE_FIELD_KEYS[fieldName];
  if (!keys) {
    return false;
  }
  const value = getPrepopulateValueFromSources(screenerOutcomeParameter, cdpData, keys);
  return value != null && value !== '';
};
